export default __webpack_public_path__ + "static/tchaikovsky-b15ef83526b6a44690ec2753e8946538.jpg";